const _ = require('lodash');
//import * as messages from '@/lang'

exports.dataStruct = [
    { country: "us", locale: "en", collabeditId: "", status: "100%", credits: "SoggyShorts, dogball", language: "English USA"},
    { country: "gb", locale: "en-gb", collabeditId: "", status: "100%", credits: "SoggyShorts, dogball", language: "English UK"},
    { locale: "de", collabeditId: "ftcs8", status: "100%", language: "Deutsch", credits: "heitz" },
    { locale: "fr", collabeditId: "ed7kr", status: "100%", language: "Français", credits: "Gamafey, Heroe, Tordhrano", },
    { locale: "es", collabeditId: "dafbt", status: "100%", language: "Español", credits: "krak93"},
    { locale: "ru", collabeditId: "pjm9a", status: "100%", language: "Русский", credits: "Друиды Fellowship",  },
    { locale: "it", collabeditId: "uckx3", status: "100%", language: "Italiano", credits: "fanusa, peperonisottaceto" },
    { locale: "pl", collabeditId: "3fq4p", status: "100%",  language: "Polski", credits: "Hara" },
    { locale: "hu", collabeditId: "pfxb9", status: "75%", language: "Magyar", credits: "petrence" },
    { locale: "nl", collabeditId: "hedq4", status: "100%", language: "Nederlands", credits: "ladiesmen"},
    { locale: "sk", collabeditId: "krgxd", status: "100%", language: "Slovenčina", credits: "ap25"},
    { locale: "se", collabeditId: "edshh", status: "15%", language: "Svenska", credits: "Lappen"},
    { locale: "dk", collabeditId: "7w58t", status: "100%", language: "Dansk", credits: "Tordhrano" },
    { locale: "pt", collabeditId: "jbqrr", status: "35%", language: "Português", credits: "Dreamsoul" },
    { locale: "br", collabeditId: "8rj97", status: "100%", language: "Português BR", credits: "MoaMaca" },
    { locale: "cs", collabeditId: "h4mbg", status: "100%", language: "Čeština", credits: "Ramik"},
    { locale: "ro", collabeditId: "45h8g", status: "35%", language: "Română", credits: "Unsure - please contact me for credits"},
    { locale: "no", collabeditId: "rp7tg", status: "0%", language: "Norsk"},
    { locale: "gr", collabeditId: "9p85n", status: "95%", language: "ελληνικά", credits: "Outlaw Kid"},
    { locale: "tr", collabeditId: "x8xve", status: "50%", language: "Türkçe", credits: "Preator"},
    { locale: "fi", collabeditId: "3tvxd", status: "50%", language: "Suomi", credits: "Naninda"},
];

exports.getLocaleCodes = function() {
    return _.map(exports.dataStruct, "locale").concat('blank');
};



exports.getLinks = function() {
    return _.map(exports.dataStruct, function(l) {
        return {
            locale: l.locale,
            link: l.collabeditId ? "http://collabedit.com/" + l.collabeditId : "",
            downloadLink: l.collabeditId ? "http://collabedit.com/download?id=" + l.collabeditId : "",
            status: l.status,
            credits: l.credits,
        }
    })
};

exports.getDownloadLink = function(locale) {
    let obj = exports.getLocale(locale);
    return obj && obj.downloadLink;
};

exports.getEditLink = function(locale) {
    let obj = exports.getLocale(locale);
    return obj && obj.link || "N/A";
};

exports.getLocale = function(locale) {
    return _.find( exports.getLinks(), {locale: locale});
};

exports.getSelectableLanguages = function() {
    return process.env.DYNAMIC_LOCALE !== "true" ? exports.getLiveList() : exports.getDevList();
};

exports.getLiveList = function() {
    const locales = ['en','en-gb','cs','de','dk','es','fr','gr','hu','it','nl','pl','ru','se','sk', 'br','ro','pt','fi','tr' ];
    return _.filter( exports.dataStruct, function(l) { return locales.indexOf( l.locale ) !== -1 });
};

exports.getDevList = function() {
    return exports.dataStruct;
};



// WEBPACK FOOTER //
// ./src/lib/translation-data.js